import React from 'react';
import { Link } from 'react-router-dom';
import { Brain } from 'lucide-react';
import Container from '../ui/Container';

const Footer: React.FC = () => {
  return (
    <footer className="bg-background border-t border-neutral-800">
      <Container>
        <div className="py-12 md:py-16">
          <div className="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-12">
            {/* Company Info */}
            <div className="md:col-span-8">
              <Link to="/" className="flex items-center space-x-2 mb-2 group">
                <div className="relative w-10 h-10">
                  <Brain 
                    size={40} 
                    className="absolute top-0 left-0 text-primary transform transition-all duration-300 group-hover:animate-[pulse_1.5s_ease-in-out_infinite]"
                    strokeWidth={1.5}
                  />
                  <div className="absolute inset-0 bg-primary/10 rounded-full opacity-0 group-hover:opacity-100 group-hover:animate-[ping_1.5s_ease-in-out_infinite] transition-opacity duration-300"></div>
                </div>
                <span className="text-2xl font-bold">Product Leap AI</span>
              </Link>
              <p className="text-sm text-primary font-medium mb-4">Building AI Strategies, Together!</p>
              <p className="text-neutral-300 mb-6">
                Clarity. Capability. Confidence. Your AI roadmap starts here.
              </p>
            </div>
            
            {/* Quick Links */}
            <div className="md:col-span-4">
              <h3 className="text-lg font-semibold mb-4">Company</h3>
              <ul className="space-y-2">
                <li><Link to="/about" className="text-neutral-300 hover:text-primary transition-colors">About Us</Link></li>
                <li><Link to="/services" className="text-neutral-300 hover:text-primary transition-colors">Services</Link></li>
                <li><Link to="/faq" className="text-neutral-300 hover:text-primary transition-colors">FAQ</Link></li>
              </ul>
            </div>
          </div>
        </div>
        
        <div className="py-6 border-t border-neutral-800">
          <div className="text-neutral-400 text-sm space-y-4">
            <p className="text-justify">
              Product Leap AI is a collaboration between ProdAI Consulting and Product Leap. ProdAI Consulting - Sole proprietorship registered with the Dutch Chamber of Commerce | KvK: 97068004. Product Leap - Sole proprietorship registered with the Dutch Chamber of Commerce | KvK: 97343137.
            </p>
            <div className="flex flex-col md:flex-row justify-between items-center gap-4">
              <p>© {new Date().getFullYear()} Product Leap AI. All rights reserved.</p>
              <div>
                <Link to="/privacy-policy" className="text-neutral-400 hover:text-primary transition-colors">
                  Privacy Policy
                </Link>
              </div>
            </div>
          </div>
        </div>
      </Container>
    </footer>
  );
};

export default Footer;